"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  z-index: 9999999;\n  background-color: transparent;\n  top: 0;\n  left: 0;\n\n  .modal-container {\n    width: 600px;\n    height: 100%;\n    position: absolute;\n    right: -600px;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    box-shadow: -0.5px 0px 5px #f0f0f0;\n    border: 1px solid #f0f0f0;\n    .modal-body {\n      flex: 1;\n    }\n\n    &.shown {\n      right: 0;\n    }\n  }\n"])));

exports.Container = Container;